// src/components/admin/AdminSamples.js (WORKING VERSION - DIRECT API CALLS)
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import api from '../../api/api';
import {
  FaUpload,
  FaEdit,
  FaTrash,
  FaEye,
  FaSearch,
  FaFilter,
  FaFilePdf,
  FaFileWord,
  FaImage,
  FaTag,
  FaBook,
  FaFileAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaSpinner,
  FaPlus,
  FaPaperclip,
  FaStar,
  FaUserGraduate,
  FaDownload,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaTimes,
  FaCheck,
  FaExclamationTriangle,
  FaDatabase,
  FaKey,
  FaUser,
  FaSignOutAlt,
  FaInfoCircle,
  FaExclamationCircle,
  FaCog,
  FaSync,
  FaQuestionCircle,
  FaList,
  FaChartBar,
  FaCalendar,
  FaLink,
  FaBug,
  FaWifi,
  FaServer,
  FaNetworkWired,
  FaExclamation,
  FaCheckSquare,
  FaSquare,
  FaBriefcase,
  FaMoneyBill,
  FaGlobeAmericas,
  FaChartLine,
  FaGraduationCap,
  FaFilm,
  FaLeaf,
  FaLandmark,
  FaHistory,
  FaBalanceScale,
  FaHeartbeat,
  FaUserCircle,
  FaBrain,
  FaUsers,
  FaFutbol,
  FaLaptopCode
} from 'react-icons/fa';
import './AdminSamples.css';

// Constants
const PAPER_TYPES = [
  { value: 'ESSAY', label: 'Essay' },
  { value: 'RESEARCH_PAPER', label: 'Research Paper' },
  { value: 'THESIS', label: 'Thesis' },
  { value: 'DISSERTATION', label: 'Dissertation' },
  { value: 'ASSIGNMENT', label: 'Assignment' },
  { value: 'TERM_PAPER', label: 'Term Paper' },
  { value: 'BOOK_REPORT', label: 'Book Report' },
  { value: 'BOOK_REVIEW', label: 'Book Review' },
  { value: 'SPEECH', label: 'Speech' },
  { value: 'PERSONAL_STATEMENT', label: 'Personal Statement' },
  { value: 'LITERATURE_REVIEW', label: 'Literature Review' },
  { value: 'ARTICLE_REVIEW', label: 'Article Review' },
  { value: 'COURSEWORK', label: 'Coursework' },
  { value: 'LAB_REPORT', label: 'Lab Report' },
  { value: 'HOMEWORK', label: 'Homework' },
  { value: 'CASE_STUDY', label: 'Case Study' },
  { value: 'CAPSTONE_PROJECT', label: 'Capstone Project' },
  { value: 'PROPOSAL', label: 'Proposal' },
  { value: 'REFLECTION_PAPER', label: 'Reflection Paper' },
  { value: 'ANNOTATED_BIBLIOGRAPHY', label: 'Annotated Bibliography' },
  { value: 'ARTICLE', label: 'Article' },
  { value: 'SUMMARY', label: 'Summary' },
  { value: 'CRITIQUE', label: 'Critique' },
  { value: 'RESEARCH_PROPOSAL', label: 'Research Proposal' },
  { value: 'SYLLABUS', label: 'Syllabus' },
  { value: 'OUTLINE', label: 'Outline' },
  { value: 'EDITING_PROOFREADING', label: 'Editing & Proofreading' },
  { value: 'REFERENCING_CITATIONS', label: 'Referencing & Citations' },
  { value: 'AI_HUMANIZER', label: 'AI Humanizer' },
  { value: 'OTHER', label: 'Other' }
];

const ACADEMIC_LEVELS = [
  { value: 'HIGH_SCHOOL', label: 'High School' },
  { value: 'COLLEGE', label: 'College' },
  { value: 'UNDERGRADUATE', label: 'Undergraduate' },
  { value: 'BACHELOR', label: 'Bachelor' },
  { value: 'MASTER', label: 'Master' },
  { value: 'PHD', label: 'PhD' },
  { value: 'DOCTORAL', label: 'Doctoral' },
  { value: 'PROFESSIONAL', label: 'Professional' }
];

const FORMAT_STYLES = [
  { value: 'APA', label: 'APA' },
  { value: 'MLA', label: 'MLA' },
  { value: 'CHICAGO', label: 'Chicago' },
  { value: 'HARVARD', label: 'Harvard' },
  { value: 'IEEE', label: 'IEEE' },
  { value: 'VANCOUVER', label: 'Vancouver' },
  { value: 'OSCOLA', label: 'OSCOLA' },
  { value: 'AGLC', label: 'AGLC' },
  { value: 'AMA', label: 'AMA' },
  { value: 'CSE', label: 'CSE' },
  { value: 'TURABIAN', label: 'Turabian' },
  { value: 'BLUEBOOK', label: 'Bluebook' },
  { value: 'OTHER', label: 'Other' },
  { value: 'NONE', label: 'None' }
];

const STATUS_OPTIONS = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'UNDER_REVIEW', label: 'Under Review' },
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'ARCHIVED', label: 'Archived' },
  { value: 'REJECTED', label: 'Rejected' }
];

const GRADES = [
  { value: '', label: 'Not Graded' },
  { value: 'A+', label: 'A+ (97-100)' },
  { value: 'A', label: 'A (93-96)' },
  { value: 'A-', label: 'A- (90-92)' },
  { value: 'B+', label: 'B+ (87-89)' },
  { value: 'B', label: 'B (83-86)' },
  { value: 'B-', label: 'B- (80-82)' },
  { value: 'C+', label: 'C+ (77-79)' },
  { value: 'C', label: 'C (73-76)' },
  { value: 'C-', label: 'C- (70-72)' },
  { value: 'D+', label: 'D+ (67-69)' },
  { value: 'D', label: 'D (65-66)' },
  { value: 'F', label: 'F (Below 65)' },
  { value: 'PASS', label: 'Pass' },
  { value: 'CREDIT', label: 'Credit' },
  { value: 'DISTINCTION', label: 'Distinction' },
  { value: 'HIGH_DISTINCTION', label: 'High Distinction' }
];

// Built-in categories that will show in the dropdown
const BUILT_IN_CATEGORIES = [
  { id: 1, name: 'Business', icon: 'briefcase' },
  { id: 2, name: 'Finance', icon: 'money-bill' },
  { id: 3, name: 'Culture', icon: 'globe-americas' },
  { id: 4, name: 'Economics', icon: 'chart-line' },
  { id: 5, name: 'Education', icon: 'graduation-cap' },
  { id: 6, name: 'Entertainment', icon: 'film' },
  { id: 7, name: 'Environment', icon: 'leaf' },
  { id: 8, name: 'Government And Politics', icon: 'landmark' },
  { id: 9, name: 'History', icon: 'history' },
  { id: 10, name: 'Law', icon: 'balance-scale' },
  { id: 11, name: 'Life Experiences', icon: 'heartbeat' },
  { id: 12, name: 'Literature', icon: 'book' },
  { id: 13, name: 'Medicine And Health', icon: 'heartbeat' },
  { id: 14, name: 'Person', icon: 'user-circle' },
  { id: 15, name: 'Philosophy', icon: 'brain' },
  { id: 16, name: 'Psychology', icon: 'brain' },
  { id: 17, name: 'Social Issues', icon: 'users' },
  { id: 18, name: 'Sociology', icon: 'users' },
  { id: 19, name: 'Sports', icon: 'futbol' },
  { id: 20, name: 'Technology', icon: 'laptop-code' }
];

const AdminSamples = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, logout, token } = useContext(AuthContext);
  
  const [mode, setMode] = useState('list');
  const [editingId, setEditingId] = useState(null);
  
  const [formData, setFormData] = useState({
    title: '',
    paper_type: 'ESSAY',
    academic_level: 'HIGH_SCHOOL',
    subject: '',
    word_count: 1000,
    page_count: 4,
    format_style: 'APA',
    grade_received: '',
    abstract: '',
    introduction: '',
    excerpt: '',
    keywords: '',
    key_features: '',
    writer_expertise: '',
    writer_rating: 4.5,
    is_featured: false,
    is_premium: false,
    requires_attribution: true,
    plagiarism_score: 0.0,
    status: 'DRAFT',
    category_id: '',
    tag_ids: []
  });
  
  const [files, setFiles] = useState({
    thumbnail: null,
    preview_pdf: null,
    full_pdf: null,
    source_file: null
  });
  
  const [filePreviews, setFilePreviews] = useState({
    thumbnail: null,
    existingThumbnail: null
  });
  
  const [samples, setSamples] = useState([]);
  const [filteredSamples, setFilteredSamples] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    status: '',
    paper_type: '',
    academic_level: '',
    is_featured: ''
  });
  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'desc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  const [backendCategories, setBackendCategories] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [tagSearch, setTagSearch] = useState('');
  
  const [stats, setStats] = useState({
    total: 0,
    published: 0,
    draft: 0,
    featured: 0
  });
  
  const [usingBuiltInCategories, setUsingBuiltInCategories] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  
  const thumbnailInputRef = useRef(null);
  const previewPdfInputRef = useRef(null);
  const fullPdfInputRef = useRef(null);
  const sourceFileInputRef = useRef(null);
  
  const itemsPerPage = 20;

  // Use built-in categories if backend categories are empty
  const categories = backendCategories.length > 0 ? backendCategories : BUILT_IN_CATEGORIES;

  useEffect(() => {
    if (isAuthenticated && user?.role !== 'ADMIN' && user?.role !== 'admin') {
      setErrorMessage('You must be an administrator to access this page.');
      setTimeout(() => navigate('/'), 3000);
    }
  }, [isAuthenticated, user, navigate]);

  useEffect(() => {
    if (mode === 'list' && isAuthenticated && (user?.role === 'ADMIN' || user?.role === 'admin')) {
      if (!dataFetched) {
        fetchAllData();
      }
    }
  }, [mode, currentPage, sortConfig, isAuthenticated, user]);

  useEffect(() => {
    applyFiltersAndSearch();
  }, [samples, searchTerm, filters]);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      setErrorMessage('');
      
      console.log('🔄 Starting to fetch all data...');
      
      // Fetch categories
      try {
        console.log('📁 Fetching categories...');
        const categoriesResponse = await api.get('/samples/categories/');
        const backendCats = categoriesResponse.data || [];
        console.log('📁 Categories from backend:', backendCats);
        setBackendCategories(backendCats);
        
        if (backendCats.length === 0) {
          setUsingBuiltInCategories(true);
          console.log('ℹ️ Using built-in categories (backend empty)');
        } else {
          setUsingBuiltInCategories(false);
        }
      } catch (catError) {
        console.error('Categories fetch error:', catError);
        setBackendCategories([]);
        setUsingBuiltInCategories(true);
      }
      
      // Fetch tags
      try {
        console.log('🏷️ Fetching tags...');
        const tagsResponse = await api.get('/samples/tags/');
        const tags = tagsResponse.data || [];
        setAllTags(tags);
        console.log('🏷️ Tags from backend:', tags.length);
      } catch (tagsError) {
        console.error('Tags fetch error:', tagsError);
        setAllTags([]);
      }
      
      // Fetch samples with admin_view=true
      try {
        console.log('📄 Fetching ALL samples with admin_view=true...');
        
        const samplesResponse = await api.get('/samples/samples/', {
          params: {
            page: currentPage,
            page_size: itemsPerPage,
            ordering: `${sortConfig.direction === 'desc' ? '-' : ''}${sortConfig.key}`,
            admin_view: true
          }
        });
        
        console.log('📊 Samples API Response:', samplesResponse.data);
        
        if (samplesResponse.data.results) {
          console.log('✅ Got paginated response with', samplesResponse.data.results.length, 'samples');
          setSamples(samplesResponse.data.results);
          setTotalPages(Math.ceil(samplesResponse.data.count / itemsPerPage));
          
          const statsData = {
            total: samplesResponse.data.count || 0,
            published: samplesResponse.data.results.filter(s => s.status === 'PUBLISHED').length,
            draft: samplesResponse.data.results.filter(s => s.status === 'DRAFT').length,
            featured: samplesResponse.data.results.filter(s => s.is_featured).length
          };
          setStats(statsData);
          
        } else if (Array.isArray(samplesResponse.data)) {
          console.log('✅ Got array response with', samplesResponse.data.length, 'samples');
          setSamples(samplesResponse.data);
          setTotalPages(1);
          
          const statsData = {
            total: samplesResponse.data.length,
            published: samplesResponse.data.filter(s => s.status === 'PUBLISHED').length,
            draft: samplesResponse.data.filter(s => s.status === 'DRAFT').length,
            featured: samplesResponse.data.filter(s => s.is_featured).length
          };
          setStats(statsData);
        }
        
      } catch (samplesError) {
        console.error('❌ Samples fetch error:', samplesError);
        setSamples([]);
        setErrorMessage(`Failed to fetch samples: ${samplesError.message}`);
      }
      
      setDataFetched(true);
      console.log('✅ Data fetch completed');
      
    } catch (error) {
      console.error('❌ Error in fetchAllData:', error);
      
      if (error.response?.status === 401 || error.response?.status === 403) {
        setErrorMessage('Authentication failed. Please login again as admin.');
        logout();
        navigate('/login', {
          state: {
            message: 'Admin access required. Please login as administrator.',
            redirectTo: '/dashboard/admin/samples'
          }
        });
      } else if (error.message?.includes('Network Error')) {
        setErrorMessage('Cannot connect to server. Please check if Django backend is running.');
      } else {
        setErrorMessage(`Failed to load data: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  // Alternative function to fetch ALL samples without pagination
  const fetchAllSamplesDirectly = async () => {
    try {
      setLoading(true);
      console.log('🔍 Fetching samples directly...');
      
      const response = await api.get('/samples/samples/', {
        params: {
          page_size: 1000,
          ordering: '-created_at',
          admin_view: true
        }
      });
      
      if (response.data.results) {
        setSamples(response.data.results);
        console.log('✅ Fetched', response.data.results.length, 'samples');
      } else if (Array.isArray(response.data)) {
        setSamples(response.data);
        console.log('✅ Fetched', response.data.length, 'samples');
      }
      
    } catch (error) {
      console.error('Direct fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const applyFiltersAndSearch = () => {
    let filtered = [...samples];

    if (searchTerm) {
      filtered = filtered.filter(sample =>
        (sample.title?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (sample.subject?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (sample.abstract?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    if (filters.status) {
      filtered = filtered.filter(sample => sample.status === filters.status);
    }
    if (filters.paper_type) {
      filtered = filtered.filter(sample => sample.paper_type === filters.paper_type);
    }
    if (filters.academic_level) {
      filtered = filtered.filter(sample => sample.academic_level === filters.academic_level);
    }
    if (filters.is_featured === 'true') {
      filtered = filtered.filter(sample => sample.is_featured === true);
    } else if (filters.is_featured === 'false') {
      filtered = filtered.filter(sample => sample.is_featured === false);
    }

    setFilteredSamples(filtered);
  };

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
    setCurrentPage(1);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort />;
    return sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleTextareaChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'abstract' && !formData.excerpt) {
      const excerpt = value.length > 200 ? value.substring(0, 200) + '...' : value;
      setFormData(prev => ({ ...prev, excerpt }));
    }
    
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (fileType, e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      setErrorMessage(`${fileType.replace('_', ' ')} size exceeds 10MB limit`);
      return;
    }

    const validExtensions = {
      thumbnail: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'],
      preview_pdf: ['.pdf'],
      full_pdf: ['.pdf'],
      source_file: ['.doc', '.docx', '.txt', '.rtf'],
    };

    const extension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    if (!validExtensions[fileType].includes(extension)) {
      setErrorMessage(`Invalid file type for ${fileType}. Allowed: ${validExtensions[fileType].join(', ')}`);
      return;
    }

    setFiles(prev => ({ ...prev, [fileType]: file }));

    if (fileType === 'thumbnail') {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFilePreviews(prev => ({ ...prev, thumbnail: reader.result }));
      };
      reader.readAsDataURL(file);
    }

    if ((fileType === 'preview_pdf' || fileType === 'full_pdf') && !formData.title) {
      const fileName = file.name.replace(/\.[^/.]+$/, "");
      const formattedTitle = fileName
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
      setFormData(prev => ({ ...prev, title: formattedTitle }));
    }
  };

  const removeFile = (fileType) => {
    setFiles(prev => ({ ...prev, [fileType]: null }));
    if (fileType === 'thumbnail') {
      setFilePreviews(prev => ({ ...prev, thumbnail: null }));
    }
  };

  const handleTagSelect = (tag) => {
    if (!formData.tag_ids.includes(tag.id)) {
      setFormData(prev => ({
        ...prev,
        tag_ids: [...prev.tag_ids, tag.id]
      }));
    }
    setTagSearch('');
  };

  const removeTag = (tagId) => {
    setFormData(prev => ({
      ...prev,
      tag_ids: prev.tag_ids.filter(id => id !== tagId)
    }));
  };

  const createNewTag = () => {
    if (tagSearch.trim()) {
      const tagName = tagSearch.trim();
      const newTag = {
        id: `temp-${Date.now()}`,
        name: tagName,
        slug: tagName.toLowerCase().replace(/\s+/g, '-')
      };
      
      setAllTags(prev => [...prev, newTag]);
      handleTagSelect(newTag);
      setSuccessMessage(`Tag "${tagName}" added. Note: This tag needs to exist in backend.`);
    }
  };

  const calculatePages = () => {
    const words = parseInt(formData.word_count) || 1000;
    const pages = Math.ceil(words / 250);
    setFormData(prev => ({ ...prev, page_count: pages }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    
    if (!formData.title.trim()) {
      setErrorMessage('Title is required');
      return;
    }
    if (!formData.subject.trim()) {
      setErrorMessage('Subject is required');
      return;
    }
    if (!formData.abstract.trim()) {
      setErrorMessage('Abstract is required');
      return;
    }

    if (!isAuthenticated || !token) {
      setErrorMessage('Authentication required. Please login again.');
      logout();
      navigate('/login', {
        state: {
          message: 'Please login to upload samples',
          redirectTo: '/dashboard/admin/samples'
        }
      });
      return;
    }

    setUploading(true);
    setProgress(0);

    try {
      const submitData = new FormData();
      
      // Add all form fields to FormData
      Object.keys(formData).forEach(key => {
        const value = formData[key];
        
        if (value === null || value === undefined || value === '') {
          return;
        }
        
        if (key === 'tag_ids' && Array.isArray(value)) {
          // Send as comma-separated string like the working version
          if (value.length > 0) {
            submitData.append(key, value.join(','));
          }
        } else if (typeof value === 'boolean') {
          submitData.append(key, value.toString());
        } else if (key === 'category_id' && value) {
          submitData.append(key, value.toString());
        } else if (key !== 'category_id' || value) {
          submitData.append(key, value);
        }
      });

      // Add files
      if (files.thumbnail) {
        submitData.append('thumbnail', files.thumbnail);
      }
      if (files.preview_pdf) {
        submitData.append('preview_pdf', files.preview_pdf);
      }
      if (files.full_pdf) {
        submitData.append('full_pdf', files.full_pdf);
      }
      if (files.source_file) {
        submitData.append('source_file', files.source_file);
      }

      // Log FormData for debugging
      console.log('📤 Submitting FormData:');
      for (let pair of submitData.entries()) {
        console.log(pair[0] + ':', pair[1] instanceof File ? pair[1].name : pair[1]);
      }

      const url = editingId ? `/samples/samples/${editingId}/` : '/samples/samples/';
      const method = editingId ? 'put' : 'post';
      
      console.log(`📤 ${method.toUpperCase()} to ${url}`);
      
      const response = await api({
        method,
        url,
        data: submitData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setProgress(percent);
          }
        }
      });

      console.log('✅ Sample saved:', response.data);
      const message = editingId ? 'Sample updated successfully!' : 'Sample uploaded successfully!';
      setSuccessMessage(message);

      setTimeout(() => {
        setMode('list');
        resetForm();
        fetchAllData();
      }, 1500);

    } catch (error) {
      console.error('❌ Error saving sample:', error);
      
      if (error.response?.status === 400) {
        const errors = error.response.data;
        let errorMsg = 'Validation errors:\n';
        
        if (typeof errors === 'object') {
          Object.keys(errors).forEach(key => {
            if (Array.isArray(errors[key])) {
              errorMsg += `• ${key}: ${errors[key].join(', ')}\n`;
            } else {
              errorMsg += `• ${key}: ${errors[key]}\n`;
            }
          });
        } else {
          errorMsg = errors.toString();
        }
        
        setErrorMessage(errorMsg);
        
      } else if (error.response?.status === 401 || error.response?.status === 403) {
        setErrorMessage('Permission denied. Only admins can upload samples.');
        
      } else if (error.response?.status === 404) {
        setErrorMessage(`Endpoint not found (404). Check if ${url} exists.`);
        
      } else if (error.response?.status === 413) {
        setErrorMessage('File too large. Maximum file size is 10MB.');
        
      } else if (error.message?.includes('Network Error')) {
        setErrorMessage('Cannot connect to server. Please check if Django backend is running.');
        
      } else {
        setErrorMessage(error.message || 'Failed to save sample. Please try again.');
      }
      
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  const handleEdit = (sample) => {
    console.log('✏️ Editing sample:', sample);
    setEditingId(sample.id);
    setMode('edit');
    
    setFormData({
      title: sample.title || '',
      paper_type: sample.paper_type || 'ESSAY',
      academic_level: sample.academic_level || 'HIGH_SCHOOL',
      subject: sample.subject || '',
      word_count: sample.word_count || 1000,
      page_count: sample.page_count || 4,
      format_style: sample.format_style || 'APA',
      grade_received: sample.grade_received || '',
      abstract: sample.abstract || '',
      introduction: sample.introduction || '',
      excerpt: sample.excerpt || '',
      keywords: sample.keywords || '',
      key_features: sample.key_features || '',
      writer_expertise: sample.writer_expertise || '',
      writer_rating: sample.writer_rating || 4.5,
      is_featured: sample.is_featured || false,
      is_premium: sample.is_premium || false,
      requires_attribution: sample.requires_attribution !== false,
      plagiarism_score: sample.plagiarism_score || 0.0,
      status: sample.status || 'DRAFT',
      category_id: sample.category?.id || '',
      tag_ids: sample.tags?.map(tag => tag.id) || []
    });

    if (sample.thumbnail_url) {
      setFilePreviews(prev => ({ ...prev, existingThumbnail: sample.thumbnail_url }));
    }

    setFiles({
      thumbnail: null,
      preview_pdf: null,
      full_pdf: null,
      source_file: null
    });
    
    setErrorMessage('');
    setSuccessMessage('');
  };

  const handleDelete = async (sampleId) => {
    if (!window.confirm('Are you sure you want to delete this sample?')) return;

    try {
      await api.delete(`/samples/samples/${sampleId}/`);
      setSuccessMessage('Sample deleted successfully!');
      fetchAllData();
    } catch (error) {
      console.error('Error deleting sample:', error);
      setErrorMessage(error.message || 'Failed to delete sample');
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      paper_type: 'ESSAY',
      academic_level: 'HIGH_SCHOOL',
      subject: '',
      word_count: 1000,
      page_count: 4,
      format_style: 'APA',
      grade_received: '',
      abstract: '',
      introduction: '',
      excerpt: '',
      keywords: '',
      key_features: '',
      writer_expertise: '',
      writer_rating: 4.5,
      is_featured: false,
      is_premium: false,
      requires_attribution: true,
      plagiarism_score: 0.0,
      status: 'DRAFT',
      category_id: '',
      tag_ids: []
    });
    
    setFiles({
      thumbnail: null,
      preview_pdf: null,
      full_pdf: null,
      source_file: null
    });
    
    setFilePreviews({
      thumbnail: null,
      existingThumbnail: null
    });
    
    setEditingId(null);
    setTagSearch('');
    setErrorMessage('');
    setSuccessMessage('');
  };

  const cancelEdit = () => {
    setMode('list');
    resetForm();
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'PUBLISHED': return 'status-published';
      case 'DRAFT': return 'status-draft';
      case 'UNDER_REVIEW': return 'status-review';
      case 'ARCHIVED': return 'status-archived';
      case 'REJECTED': return 'status-rejected';
      default: return 'status-draft';
    }
  };

  // Get icon component for category
  const getCategoryIcon = (categoryName) => {
    const category = BUILT_IN_CATEGORIES.find(cat => cat.name === categoryName);
    if (!category) return <FaBook />;
    
    switch(category.icon) {
      case 'briefcase': return <FaBriefcase />;
      case 'money-bill': return <FaMoneyBill />;
      case 'globe-americas': return <FaGlobeAmericas />;
      case 'chart-line': return <FaChartLine />;
      case 'graduation-cap': return <FaGraduationCap />;
      case 'film': return <FaFilm />;
      case 'leaf': return <FaLeaf />;
      case 'landmark': return <FaLandmark />;
      case 'history': return <FaHistory />;
      case 'balance-scale': return <FaBalanceScale />;
      case 'heartbeat': return <FaHeartbeat />;
      case 'book': return <FaBook />;
      case 'user-circle': return <FaUserCircle />;
      case 'brain': return <FaBrain />;
      case 'users': return <FaUsers />;
      case 'futbol': return <FaFutbol />;
      case 'laptop-code': return <FaLaptopCode />;
      default: return <FaBook />;
    }
  };

  const debugFetch = async () => {
    console.log('🐛 DEBUG: Current state:', {
      samplesCount: samples.length,
      filteredCount: filteredSamples.length,
      dataFetched,
      loading,
      errorMessage
    });
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-auth-required">
        <div className="auth-required-message">
          <FaExclamationCircle className="auth-icon" />
          <h2>Authentication Required</h2>
          <p>Please login to access the admin panel.</p>
          <button 
            onClick={() => navigate('/login', { state: { redirectTo: '/dashboard/admin/samples' } })}
            className="auth-login-btn"
          >
            <FaUser /> Login
          </button>
        </div>
      </div>
    );
  }

  if (user?.role !== 'ADMIN' && user?.role !== 'admin') {
    return (
      <div className="admin-permission-denied">
        <div className="permission-denied-message">
          <FaExclamationTriangle className="permission-icon" />
          <h2>Admin Access Required</h2>
          <p>You must be an administrator to access this page.</p>
          <p>Your role: {user?.role}</p>
          <button 
            onClick={() => navigate('/')}
            className="permission-home-btn"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-samples-container">
      <div className="admin-main-content">
        <div className="admin-header">
          <div className="admin-header-left">
            <h1>
              <FaFileAlt className="header-icon" />
              Sample Management
            </h1>
            <div className="admin-user-info">
              <FaUser className="user-icon" />
              <span className="user-name">{user?.username || user?.email}</span>
              <span className="user-role">({user?.role})</span>
              <button 
                onClick={logout}
                className="logout-btn"
                title="Logout"
              >
                <FaSignOutAlt /> Logout
              </button>
            </div>
          </div>
          
          <div className="admin-header-right">
            <button 
              className="btn-primary"
              onClick={() => {
                resetForm();
                setMode('upload');
              }}
              title="Upload new sample"
            >
              <FaUpload /> Upload New Sample
            </button>
            <button 
              className="btn-secondary debug-btn"
              onClick={debugFetch}
              title="Debug API"
            >
              <FaBug /> Debug
            </button>
          </div>
        </div>

        {successMessage && (
          <div className="message success">
            <FaCheckCircle /> {successMessage}
          </div>
        )}
        {errorMessage && (
          <div className="message error">
            <FaTimesCircle /> {errorMessage}
            <button 
              onClick={() => setErrorMessage('')}
              className="btn-close-error"
            >
              <FaTimes />
            </button>
          </div>
        )}

        <div className="connection-status">
          <div className={`status-indicator ${samples.length > 0 ? 'connected' : 'disconnected'}`}>
            <FaServer /> {samples.length > 0 ? 'Connected' : 'No Connection'}
          </div>
          <div className="status-info">
            <span>Samples: {samples.length} | Filtered: {filteredSamples.length}</span>
            <button onClick={fetchAllData} className="btn-refresh-small">
              <FaSync /> Refresh
            </button>
          </div>
        </div>

        {usingBuiltInCategories && (
          <div className="builtin-categories-notice">
            <FaExclamationTriangle className="notice-icon" />
            <div className="notice-content">
              <strong>Using Built-in Categories</strong>
              <p>
                Categories are loaded from frontend. For permanent categories, 
                <a href="http://127.0.0.1:8000/admin/samples/samplecategory/add/" target="_blank" rel="noopener noreferrer">
                  create them in Django Admin
                </a>
              </p>
            </div>
          </div>
        )}

        <div className="admin-stats">
          <div className="stat-card">
            <div className="stat-icon total">
              <FaFileAlt />
            </div>
            <div className="stat-content">
              <h3>{stats.total}</h3>
              <p>Total Samples</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon published">
              <FaCheckCircle />
            </div>
            <div className="stat-content">
              <h3>{stats.published}</h3>
              <p>Published</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon draft">
              <FaEdit />
            </div>
            <div className="stat-content">
              <h3>{stats.draft}</h3>
              <p>Drafts</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon featured">
              <FaStar />
            </div>
            <div className="stat-content">
              <h3>{stats.featured}</h3>
              <p>Featured</p>
            </div>
          </div>
        </div>

        {mode === 'list' ? (
          <div className="admin-list-content">
            <div className="toolbar">
              <div className="search-box">
                <FaSearch />
                <input
                  type="text"
                  placeholder="Search samples..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  disabled={samples.length === 0}
                />
                {searchTerm && (
                  <button 
                    className="clear-search"
                    onClick={() => setSearchTerm('')}
                  >
                    <FaTimes />
                  </button>
                )}
              </div>

              <div className="filters">
                <select 
                  value={filters.status} 
                  onChange={(e) => setFilters(prev => ({ ...prev, status: e.target.value }))}
                  disabled={samples.length === 0}
                >
                  <option value="">All Status</option>
                  {STATUS_OPTIONS.map(status => (
                    <option key={status.value} value={status.value}>{status.label}</option>
                  ))}
                </select>

                <select 
                  value={filters.paper_type} 
                  onChange={(e) => setFilters(prev => ({ ...prev, paper_type: e.target.value }))}
                  disabled={samples.length === 0}
                >
                  <option value="">All Types</option>
                  {PAPER_TYPES.map(type => (
                    <option key={type.value} value={type.value}>{type.label}</option>
                  ))}
                </select>

                <select 
                  value={filters.academic_level} 
                  onChange={(e) => setFilters(prev => ({ ...prev, academic_level: e.target.value }))}
                  disabled={samples.length === 0}
                >
                  <option value="">All Levels</option>
                  {ACADEMIC_LEVELS.map(level => (
                    <option key={level.value} value={level.value}>{level.label}</option>
                  ))}
                </select>
                
                <select 
                  value={filters.is_featured} 
                  onChange={(e) => setFilters(prev => ({ ...prev, is_featured: e.target.value }))}
                  disabled={samples.length === 0}
                >
                  <option value="">All</option>
                  <option value="true">Featured</option>
                  <option value="false">Not Featured</option>
                </select>
                
                {Object.values(filters).some(f => f !== '') && (
                  <button 
                    className="clear-filters"
                    onClick={() => setFilters({ status: '', paper_type: '', academic_level: '', is_featured: '' })}
                  >
                    <FaTimes /> Clear
                  </button>
                )}
              </div>
            </div>

            <div className="table-container">
              {loading ? (
                <div className="loading">
                  <FaSpinner className="spinner" /> Loading samples...
                </div>
              ) : samples.length === 0 ? (
                <div className="no-results">
                  <FaFileAlt />
                  <p>No samples found in database</p>
                  <p className="no-results-help">
                    This could mean:
                    <br />1. The backend API is not returning data
                    <br />2. No samples exist in the database
                    <br />3. There's a permission/authentication issue
                  </p>
                  <div className="no-results-actions">
                    <button onClick={fetchAllData} className="btn-refresh">
                      <FaSync /> Refresh Data
                    </button>
                    <button onClick={fetchAllSamplesDirectly} className="btn-test">
                      <FaDatabase /> Try Direct Fetch
                    </button>
                    <button onClick={() => {
                      resetForm();
                      setMode('upload');
                    }} className="btn-create">
                      <FaUpload /> Create First Sample
                    </button>
                  </div>
                  <div className="debug-info">
                    <FaQuestionCircle /> Check browser console for detailed error messages
                  </div>
                </div>
              ) : filteredSamples.length === 0 ? (
                <div className="no-results">
                  <FaSearch />
                  <p>No samples match your filters</p>
                  <button onClick={() => {
                    setSearchTerm('');
                    setFilters({ status: '', paper_type: '', academic_level: '', is_featured: '' });
                  }} className="btn-clear-filters">
                    Clear Filters
                  </button>
                </div>
              ) : (
                <>
                  <table className="samples-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th onClick={() => handleSort('paper_type')}>
                          Type {getSortIcon('paper_type')}
                        </th>
                        <th onClick={() => handleSort('academic_level')}>
                          Level {getSortIcon('academic_level')}
                        </th>
                        <th onClick={() => handleSort('views')}>
                          Views {getSortIcon('views')}
                        </th>
                        <th onClick={() => handleSort('status')}>
                          Status {getSortIcon('status')}
                        </th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredSamples.map(sample => (
                        <tr key={sample.id} className={sample.is_featured ? 'featured' : ''}>
                          <td className="sample-id">#{sample.id}</td>
                          <td>
                            <div className="sample-title">
                              {sample.thumbnail_url && (
                                <img src={sample.thumbnail_url} alt="" className="sample-thumb" />
                              )}
                              <div>
                                <strong>{sample.title}</strong>
                                <small>{sample.subject}</small>
                                {sample.is_featured && <FaStar className="featured-star" />}
                                {sample.is_premium && <span className="premium-badge">PREMIUM</span>}
                              </div>
                            </div>
                          </td>
                          <td>{PAPER_TYPES.find(t => t.value === sample.paper_type)?.label || sample.paper_type}</td>
                          <td>{ACADEMIC_LEVELS.find(l => l.value === sample.academic_level)?.label || sample.academic_level}</td>
                          <td>
                            <div className="stats">
                              <span className="views"><FaEye /> {sample.views || 0}</span>
                              <span className="downloads"><FaDownload /> {sample.downloads || 0}</span>
                            </div>
                          </td>
                          <td>
                            <span className={`status-badge ${getStatusBadgeClass(sample.status)}`}>
                              {STATUS_OPTIONS.find(s => s.value === sample.status)?.label || sample.status}
                            </span>
                          </td>
                          <td>
                            <div className="action-buttons">
                              <a 
                                href={`/samples/${sample.slug}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="btn-action view"
                                title="View"
                              >
                                <FaEye />
                              </a>
                              <button 
                                onClick={() => handleEdit(sample)}
                                className="btn-action edit"
                                title="Edit"
                              >
                                <FaEdit />
                              </button>
                              <button 
                                onClick={() => handleDelete(sample.id)}
                                className="btn-action delete"
                                title="Delete"
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {totalPages > 1 && (
                    <div className="pagination">
                      <button 
                        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      <span>Page {currentPage} of {totalPages}</span>
                      <button 
                        onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="admin-form-content">
            <div className="form-header">
              <h2>
                {editingId ? <FaEdit /> : <FaUpload />}
                {editingId ? 'Edit Sample' : 'Upload New Sample'}
              </h2>
              <button className="btn-back" onClick={cancelEdit}>
                <FaTimes /> Back to List
              </button>
            </div>
            
            <div className="form-container">
              <form onSubmit={handleSubmit}>
                <div className="form-section">
                  <h3><FaInfoCircle /> Basic Information</h3>
                  <div className="form-grid">
                    <div className="form-group">
                      <label>Title *</label>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        placeholder="Enter sample title"
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Paper Type *</label>
                      <select
                        name="paper_type"
                        value={formData.paper_type}
                        onChange={handleInputChange}
                      >
                        {PAPER_TYPES.map(type => (
                          <option key={type.value} value={type.value}>
                            {type.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label>Academic Level *</label>
                      <select
                        name="academic_level"
                        value={formData.academic_level}
                        onChange={handleInputChange}
                      >
                        {ACADEMIC_LEVELS.map(level => (
                          <option key={level.value} value={level.value}>
                            {level.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label>Subject *</label>
                      <input
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        placeholder="e.g., Business, Psychology, History"
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Category {usingBuiltInCategories && '(Built-in)'}</label>
                      <select
                        name="category_id"
                        value={formData.category_id}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Category (Optional)</option>
                        {categories.map(cat => (
                          <option key={cat.id} value={cat.id}>
                            {getCategoryIcon(cat.name)} {cat.name}
                          </option>
                        ))}
                      </select>
                      {usingBuiltInCategories && (
                        <small className="form-hint">
                          Note: Built-in categories may not exist in backend. 
                          <a href="http://127.0.0.1:8000/admin/samples/samplecategory/add/" target="_blank" rel="noopener noreferrer">
                            Create categories in Django Admin for persistence
                          </a>
                        </small>
                      )}
                    </div>
                    
                    <div className="form-group">
                      <label>Format Style</label>
                      <select
                        name="format_style"
                        value={formData.format_style}
                        onChange={handleInputChange}
                      >
                        {FORMAT_STYLES.map(format => (
                          <option key={format.value} value={format.value}>
                            {format.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label>Grade Received</label>
                      <select
                        name="grade_received"
                        value={formData.grade_received}
                        onChange={handleInputChange}
                      >
                        {GRADES.map(grade => (
                          <option key={grade.value} value={grade.value}>
                            {grade.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label>Word Count *</label>
                      <input
                        type="number"
                        name="word_count"
                        value={formData.word_count}
                        onChange={handleInputChange}
                        min="100"
                        max="100000"
                        step="100"
                        onBlur={calculatePages}
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Page Count</label>
                      <input
                        type="number"
                        name="page_count"
                        value={formData.page_count}
                        onChange={handleInputChange}
                        min="1"
                        max="500"
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                
                <div className="form-section">
                  <h3><FaBook /> Content</h3>
                  <div className="form-group">
                    <label>Abstract *</label>
                    <textarea
                      name="abstract"
                      value={formData.abstract}
                      onChange={handleTextareaChange}
                      placeholder="Enter a brief summary of the paper..."
                      rows="4"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Introduction</label>
                    <textarea
                      name="introduction"
                      value={formData.introduction}
                      onChange={handleTextareaChange}
                      placeholder="Enter the introduction section..."
                      rows="8"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Excerpt (for preview cards)</label>
                    <textarea
                      name="excerpt"
                      value={formData.excerpt}
                      onChange={handleTextareaChange}
                      placeholder="Short excerpt for preview cards (max 300 characters)..."
                      rows="2"
                      maxLength="300"
                    />
                    <small>{formData.excerpt.length}/300 characters</small>
                  </div>
                  
                  <div className="form-group">
                    <label>Keywords</label>
                    <textarea
                      name="keywords"
                      value={formData.keywords}
                      onChange={handleTextareaChange}
                      placeholder="Enter keywords separated by commas..."
                      rows="2"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Key Features</label>
                    <textarea
                      name="key_features"
                      value={formData.key_features}
                      onChange={handleTextareaChange}
                      placeholder="Enter key features (one per line)..."
                      rows="3"
                    />
                  </div>
                </div>
                
                <div className="form-section">
                  <h3><FaPaperclip /> Files</h3>
                  <div className="file-upload-grid">
                    <div className="file-upload-group">
                      <label>Thumbnail Image</label>
                      <div className="file-upload-area" onClick={() => thumbnailInputRef.current.click()}>
                        {filePreviews.thumbnail || filePreviews.existingThumbnail ? (
                          <div className="file-preview">
                            <img 
                              src={filePreviews.thumbnail || filePreviews.existingThumbnail} 
                              alt="Thumbnail preview" 
                            />
                            <button 
                              type="button" 
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFile('thumbnail');
                              }}
                              className="remove-file-btn"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <>
                            <FaImage className="file-icon" />
                            <span>Click to upload thumbnail</span>
                            <small>JPG, PNG, GIF (max 10MB)</small>
                          </>
                        )}
                      </div>
                      <input
                        type="file"
                        ref={thumbnailInputRef}
                        onChange={(e) => handleFileChange('thumbnail', e)}
                        accept=".jpg,.jpeg,.png,.gif,.bmp,.webp"
                        hidden
                      />
                    </div>
                    
                    <div className="file-upload-group">
                      <label>Preview PDF</label>
                      <div className="file-upload-area" onClick={() => previewPdfInputRef.current.click()}>
                        {files.preview_pdf ? (
                          <div className="file-info">
                            <FaFilePdf className="file-icon" />
                            <span>{files.preview_pdf.name}</span>
                            <small>{formatFileSize(files.preview_pdf.size)}</small>
                            <button 
                              type="button" 
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFile('preview_pdf');
                              }}
                              className="remove-file-btn"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <>
                            <FaFilePdf className="file-icon" />
                            <span>Click to upload preview PDF</span>
                            <small>PDF (max 10MB)</small>
                          </>
                        )}
                      </div>
                      <input
                        type="file"
                        ref={previewPdfInputRef}
                        onChange={(e) => handleFileChange('preview_pdf', e)}
                        accept=".pdf"
                        hidden
                      />
                    </div>
                    
                    <div className="file-upload-group">
                      <label>Full PDF</label>
                      <div className="file-upload-area" onClick={() => fullPdfInputRef.current.click()}>
                        {files.full_pdf ? (
                          <div className="file-info">
                            <FaFilePdf className="file-icon" />
                            <span>{files.full_pdf.name}</span>
                            <small>{formatFileSize(files.full_pdf.size)}</small>
                            <button 
                              type="button" 
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFile('full_pdf');
                              }}
                              className="remove-file-btn"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <>
                            <FaFilePdf className="file-icon" />
                            <span>Click to upload full PDF</span>
                            <small>PDF (max 10MB)</small>
                          </>
                        )}
                      </div>
                      <input
                        type="file"
                        ref={fullPdfInputRef}
                        onChange={(e) => handleFileChange('full_pdf', e)}
                        accept=".pdf"
                        hidden
                      />
                    </div>
                    
                    <div className="file-upload-group">
                      <label>Source File (Optional)</label>
                      <div className="file-upload-area" onClick={() => sourceFileInputRef.current.click()}>
                        {files.source_file ? (
                          <div className="file-info">
                            <FaFileWord className="file-icon" />
                            <span>{files.source_file.name}</span>
                            <small>{formatFileSize(files.source_file.size)}</small>
                            <button 
                              type="button" 
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFile('source_file');
                              }}
                              className="remove-file-btn"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <>
                            <FaFileWord className="file-icon" />
                            <span>Click to upload source file</span>
                            <small>DOC, DOCX, TXT (max 10MB)</small>
                          </>
                        )}
                      </div>
                      <input
                        type="file"
                        ref={sourceFileInputRef}
                        onChange={(e) => handleFileChange('source_file', e)}
                        accept=".doc,.docx,.txt,.rtf"
                        hidden
                      />
                    </div>
                  </div>
                </div>
                
                <div className="form-section">
                  <h3><FaTag /> Tags</h3>
                  <div className="form-group">
                    <label>Add Tags</label>
                    <div className="tags-input-container">
                      <div className="tags-display">
                        {formData.tag_ids.map(tagId => {
                          const tag = allTags.find(t => t.id === tagId);
                          return tag ? (
                            <span key={tagId} className="tag">
                              {tag.name}
                              <button
                                type="button"
                                onClick={() => removeTag(tagId)}
                                className="remove-tag"
                              >
                                <FaTimes />
                              </button>
                            </span>
                          ) : null;
                        })}
                      </div>
                      <div className="tags-search">
                        <input
                          type="text"
                          value={tagSearch}
                          onChange={(e) => setTagSearch(e.target.value)}
                          placeholder="Search or add tags..."
                        />
                        {tagSearch.trim() && (
                          <div className="tags-suggestions">
                            {allTags
                              .filter(tag => 
                                tag.name.toLowerCase().includes(tagSearch.toLowerCase()) &&
                                !formData.tag_ids.includes(tag.id)
                              )
                              .map(tag => (
                                <div
                                  key={tag.id}
                                  className="tag-suggestion"
                                  onClick={() => handleTagSelect(tag)}
                                >
                                  {tag.name}
                                </div>
                              ))}
                            <div
                              className="tag-suggestion new-tag"
                              onClick={createNewTag}
                            >
                              <FaPlus /> Create "{tagSearch}"
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="form-section">
                  <h3><FaCog /> Settings</h3>
                  <div className="settings-grid">
                    <div className="form-group checkbox-group">
                      <label>
                        <input
                          type="checkbox"
                          name="is_featured"
                          checked={formData.is_featured}
                          onChange={handleInputChange}
                        />
                        <span>Featured Sample</span>
                      </label>
                    </div>
                    
                    <div className="form-group checkbox-group">
                      <label>
                        <input
                          type="checkbox"
                          name="is_premium"
                          checked={formData.is_premium}
                          onChange={handleInputChange}
                        />
                        <span>Premium Sample (requires login)</span>
                      </label>
                    </div>
                    
                    <div className="form-group checkbox-group">
                      <label>
                        <input
                          type="checkbox"
                          name="requires_attribution"
                          checked={formData.requires_attribution}
                          onChange={handleInputChange}
                        />
                        <span>Requires Attribution</span>
                      </label>
                    </div>
                    
                    <div className="form-group">
                      <label>Status</label>
                      <select
                        name="status"
                        value={formData.status}
                        onChange={handleInputChange}
                      >
                        {STATUS_OPTIONS.map(status => (
                          <option key={status.value} value={status.value}>
                            {status.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label>Plagiarism Score (%)</label>
                      <input
                        type="number"
                        name="plagiarism_score"
                        value={formData.plagiarism_score}
                        onChange={handleInputChange}
                        min="0"
                        max="100"
                        step="0.01"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Writer Rating</label>
                      <input
                        type="number"
                        name="writer_rating"
                        value={formData.writer_rating}
                        onChange={handleInputChange}
                        min="0"
                        max="5"
                        step="0.1"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Writer Expertise</label>
                      <input
                        type="text"
                        name="writer_expertise"
                        value={formData.writer_expertise}
                        onChange={handleInputChange}
                        placeholder="e.g., Expert in Business, PhD in Psychology"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="form-section submit-section">
                  {uploading && (
                    <div className="upload-progress">
                      <div className="progress-bar">
                        <div 
                          className="progress-fill" 
                          style={{ width: `${progress}%` }}
                        ></div>
                      </div>
                      <span>{progress}%</span>
                      <FaSpinner className="spinner" />
                    </div>
                  )}
                  
                  <div className="form-actions">
                    <button
                      type="button"
                      onClick={cancelEdit}
                      className="btn-secondary"
                      disabled={uploading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-primary"
                      disabled={uploading}
                    >
                      {uploading ? (
                        <>
                          <FaSpinner className="spinner" /> {editingId ? 'Updating...' : 'Uploading...'}
                        </>
                      ) : (
                        <>
                          {editingId ? <FaEdit /> : <FaUpload />}
                          {editingId ? 'Update Sample' : 'Upload Sample'}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSamples;
